import React from 'react';
import classnames from 'classnames';
import { connect } from "react-redux";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { getLanguage } from '../../../store/apiWrapper';
import { isNullOrUndefined } from '../../../store/storeFunctions';

class ITradeLineChart extends React.Component {
    index = 'index';
    avg = 'avg';

    indexColor = "#14b8b1";
    avgColor = "#013f7c";

    state = { activePoint: null }

    render() {
        if (!Array.isArray(this.props.data) || this.props.data.length === 0)
            return null;

        return (
            <>
                {this.props.header && <span className="underlined-title-wrapper">
                    <span className="underlined-title">{this.props.header}</span>
                </span>}
                {this.renderChart("hide-on-mobile", { top: 30, right: 50, left: 20, bottom: 5 }, 60, -20)}
                {this.renderChart("hide-on-desktop", { top: 30, right: 30, left: 0, bottom: 5 }, 40, -10)}
            </>
        );
    }

    renderChart = (cssDisplayModeClass, chartMargin, yAxisWidth, yAxisLabelOffset) => {
        return (
            <ResponsiveContainer width="99%" height={300} className={cssDisplayModeClass}>
                <LineChart data={this.props.data} margin={chartMargin} onClick={this.lineChartClick}>
                    <CartesianGrid vertical={false} stroke="#eee" />
                    <XAxis stroke="#8d949e" type="category" dataKey="period" tickFormatter={(period) => this.formatDate(period)} />
                    <YAxis width={yAxisWidth} stroke="#8d949e" minTickGap={0.1} tick={{}} type="number"
                        label={{ value: this.props.isRepi ? this.props.label : "REPI Index", angle: -90, fontSize: "0.8em", dx: yAxisLabelOffset }}
                        ticks={this.getTicks(this.getMinMaxes(this.props.data, true))}
                        domain={this.getMinMaxes(this.props.data)}
                    />
                    <Tooltip cursor={false} content={<CustomTooltip />} wrapperStyle={tooltipStyle} />
                    <Line type="monotone" strokeWidth="3"
                        label={(payload) => this.xLabel(payload, this.indexColor)}
                        dataKey={this.index} stroke={this.indexColor}
                        dot={{ stroke: this.indexColor, strokeWidth: 3 }} />
                    <Line type="monotone" strokeWidth="3" strokeDasharray="10 10"
                        label={(payload) => this.xLabel(payload, this.avgColor)}
                        dataKey={this.avg} stroke={this.avgColor}
                        dot={{ stroke: this.avgColor, strokeWidth: 3, strokeDasharray: "0 0" }} />
                </LineChart>
            </ResponsiveContainer>
        );
    }

    getMinMaxes = (data, toObject = false) => {
        let minAvg = Math.min(...data.map(d => (d.avg !== null) ? d.avg : 0));
        let maxAvg = Math.max(...data.map(d => (d.avg !== null) ? d.avg : 0))
        let minIndex = Math.min(...data.map(d => (d.index !== null) ? d.index : 0));
        let maxIndex = Math.max(...data.map(d => (d.index !== null) ? d.index : 0))

        return !toObject
            ? [Math.min(...[minAvg, maxAvg, minIndex, maxIndex]), Math.max(...[minAvg, maxAvg, minIndex, maxIndex])]
            : { min: Math.min(...[minAvg, maxAvg, minIndex, maxIndex]), max: Math.max(...[minAvg, maxAvg, minIndex, maxIndex]) };
    }

    xLabel = (payload, fill, xOffset = 0) => {
        return (
            <g className={classnames({ "hide-on-mobile": payload.index !== this.state.activePoint })}>
                <text fontWeight="600" fontSize="0.875em" fill={fill} x={payload.x + xOffset} y={payload.y - 10}>
                    {(payload.value || payload.value === 0) ? payload.value.toFixed(1) : null}
                </text>
            </g>
        );
    }

    getTicks = (minMaxes) => {
        let x = [];
        for (let i = minMaxes.min; i <= minMaxes.max; i += 1)
            x.push(i);
        return x;
    }

    formatDate = (date) => {
        let month = new Date(date).toLocaleString(getLanguage(), { month: "short" });
        let year = new Date(date).getFullYear().toString().substring(2, 4);
        return `${month} ${year}`;
    }

    lineChartClick = e => this.setState({ activePoint: e && e.activeTooltipIndex });
}

const tooltipStyle = {
    textAlign: "center",
    fontSize: "0.8em",
    padding: "0.35em 2em",
    background: "#FFF",
    border: "1px solid #DEDEDE",
    boxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)",
    WebkitBoxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)"
}

const CustomTooltip = ({ active, payload }) => {
    if (!active || isNullOrUndefined(payload) || payload.length === 0)
        return null;

    const index = payload[0].payload.index === null ? "N/A" : payload[0].payload.index.toFixed(1);
    const avg = payload[0].payload.avg === null ? "N/A" : payload[0].payload.avg.toFixed(1);

    return (
        <div className="payment-chart-tooltip">
            <div style={{ display: "flex", flexBasis: "15%", textAlign: "center", justifyContent: "center" }}>
                <div className="is-inline-block trade-line-chart-legend-d" style={{ marginRight: "5px", width: "20px", height: "0.8em", marginTop: "0.5em" }}></div>
                <div style={{ fontWeight: "600", fontSize: "1.2em", minWidth: "3em" }}>{index} </div>
            </div>
            <div style={{ display: "flex", flexBasis: "15%", textAlign: "center", justifyContent: "center" }}>
                <div className="is-inline-block trade-line-chart-legend-text" style={{ marginRight: "5px", width: "20px", height: "0.8em", marginTop: "0.5em" }}></div>
                <div style={{ fontWeight: "600", fontSize: "1.2em", minWidth: "3em" }}>{avg} </div>
            </div>
            <div style={{ fontSize: "1em" }}>{new Date(payload[0].payload.period).toLocaleDateString("cs")}</div>
        </div>
    )
}

export default connect(state => state.userContext, null)(ITradeLineChart);